import type { Ref, RefCallback } from 'react';

import { setRef } from './setRef';

/** One callback ref that fills all the given refs, e.g. a component's own ref and the one it receives. */
export function mergeRefs<T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> {
    return (value) => {
        refs.forEach((ref) => setRef(ref, value));
    };
}
